import { render, staticRenderFns } from "./GemeenteBeknopt.vue?vue&type=template&id=6e7b2fdf&"
import script from "./GemeenteBeknopt.vue?vue&type=script&lang=js&"
export * from "./GemeenteBeknopt.vue?vue&type=script&lang=js&"
import style0 from "./GemeenteBeknopt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GemeenteBeknopt.vue"
export default component.exports